import { iteroErrorMessage } from '../../../../services/iteroConnection';
import { uiErrorMessage } from '../../../../utils/apiError';
import { UserFacingError } from '../../../../utils/userFacingError';
import { isTimeoutError } from './iteroBrowseErrors';

const TIMEOUT_TEXT = 'iTero took too long to respond. Try again in a moment.';

export function browseErrorText(error: unknown, fallback: string): string {
    if (isTimeoutError(error)) return TIMEOUT_TEXT;
    if (error instanceof UserFacingError) return uiErrorMessage(error, fallback);
    return iteroErrorMessage(error, fallback);
}
